
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useMixins } from '@/modules/chat/sentence/model/mixins';
import { ROUTE_NAME_CHAT } from '@/modules/chat/router';

export default defineComponent({
    name: ROUTE_NAME_CHAT.SENTENCE.ADD,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, actions } = useMixins();

        return { model, v$, actions };
    }
});
